import {i18n} from '@/lang/index'

export const RESOURCE_DETAIL_PAGE_SIZE = 10

const RESOURCE_SOURCE_TYPE_TEXT_MAP = {
  1: 'resource_detail.source_type.1',
  2: 'resource_detail.source_type.2',
  3: 'resource_detail.source_type.3',
  4: 'resource_detail.source_type.4'
}

export function getResourceSourceTypeText(type) {
  const messageKey = RESOURCE_SOURCE_TYPE_TEXT_MAP[Number(type)]
  return messageKey ? i18n.global.t(messageKey) : '-'
}

export function getResourceDetailList(result) {
  if (Array.isArray(result)) {
    return result
  }

  if (Array.isArray(result?.records)) {
    return result.records
  }

  if (Array.isArray(result?.list)) {
    return result.list
  }

  if (Array.isArray(result?.data)) {
    return result.data
  }

  return []
}

export function getResourceDetailPageData(result = {}) {
  return {
    records: getResourceDetailList(result),
    total: Number(result?.total) || 0,
    size: Number(result?.size) || RESOURCE_DETAIL_PAGE_SIZE,
    current: Number(result?.current) || 1
  }
}
